<!-- =========================================================================================
    File Name: CardActions.vue
    Description: Card with actions
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<vx-card :title="$t('CompanyModule.Summary')" no-shadow card-border>
		<p>{{ $t("CompanyModule.ChechInfo") }}</p>
		<div class="vx-row">
			<div class="vx-col mb-base lg:w-1/2 md:w-1/1">
				<vx-card :title="$t('Company')" no-shadow>
					<table style="width: 100%" class="border-collapse">
						<caption></caption>
						<tr>
							<th class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("Information") }}
							</th>
							<th class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("UploadFiles.Details") }}
							</th>
						</tr>
						<tr>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("CompanyCreate.CompanyName") }}
							</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ company.name }}
							</td>
						</tr>
						<tr>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("Address") }}
							</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ company.address }}
							</td>
						</tr>
						<tr>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("CompanyCreate.Phone") }}
							</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ company.phone }}
							</td>
						</tr>
						<tr>
							<td class="p-2 border border-solid d-theme-border-grey-light">Nit</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ company.nit }}
							</td>
						</tr>
						<tr>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("CompanyCreate.InitDate") }} - {{ $t("CompanyCreate.EndDate") }}
							</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ company.date_init }} - {{ company.date_end }}
							</td>
						</tr>
						<tr>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("CompanyCreate.ContactPerson") }}
							</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ company.contac_persons }}
							</td>
						</tr>
						<tr>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("Country") }}
							</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ company.country }}
							</td>
						</tr>
						<tr>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("City") }}
							</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ company.city }}
							</td>
						</tr>
						<tr>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("Description") }}
							</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ company.description }}
							</td>
						</tr>
					</table>
				</vx-card>
			</div>

			<div class="vx-col lg:w-1/2 mb-base md:w-1/1" v-show="mode === 'create' || mode === 'createAdmin'">
				<vx-card :title="$t('CompanyModule.AdminResource')" no-shadow>
					<table style="width: 100%" class="border-collapse">
						<caption></caption>
						<tr>
							<th class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("Information") }}
							</th>
							<th class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("UploadFiles.Details") }}
							</th>
						</tr>
						<tr>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("Name") }}
							</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ resource.name }}
							</td>
						</tr>
						<tr>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("ResourceModule.Table.Lastname") }}
							</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ resource.lastname }}
							</td>
						</tr>
						<tr>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("Username") }}
							</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ resource.username }}
							</td>
						</tr>
						<tr>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("Email") }}
							</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ resource.email }}
							</td>
						</tr>
						<tr>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("Identification") }}
							</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ resource.identification }}
							</td>
						</tr>
					</table>
				</vx-card>
			</div>
		</div>
	</vx-card>
</template>

<script>
import Company from "@/models/Company.js";

export default {
	props: {
		resource: {
			type: Object,
			default: () => {},
		},
		company: {
			type: Company,
			default: () => new Company({}),
		},
		mode: {
			type: String,
			default: "create",
		},
	},
	data() {
		return {activeAlert: true};
	},
	methods: {},
};
</script>
